import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({ article }: { article: ArticleCardProps }) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
          <img
            src={article.coverImage}
            alt={article.title}
            title={`${article.title} - 爱威奶在线`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 mb-3">
            <span className="px-2.5 py-0.5 bg-primary-50 text-primary-700 rounded-full text-xs font-medium">
              {article.category}
            </span>
            <span className="text-xs text-foreground-400">{article.readTime}</span>
          </div>
          <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-500 mb-4 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between">
            <span className="text-xs text-foreground-400">{article.author} · {article.date}</span>
            <span className="text-xs text-primary-600 font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              阅读全文 <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}